import {useEffect} from 'react'
import {useSnapshot} from 'valtio'
import {useLocation} from 'react-router'
import {store} from '@/form.js'
import {CardPage} from '@/pages/CardFlow/CardPage/CardPage.jsx'
import {CardStatusPage} from '@/pages/CardFlow/CardStatusPage/CardStatusPage.jsx'
import {LoadingPage} from '@/pages/CardFlow/LoadingPage.jsx'

// The ACS returns the payer to /finish after 3-D Secure, carrying the result
// in the query string.
const FINISH_PATH = '/finish'

export function CardFlow() {
  const formState = useSnapshot(store.cardFormSlice.state)
  const loc = useLocation()

  const isFinish = loc.pathname === FINISH_PATH
  const hasResult = !!formState.update.data
  const needsInit = !isFinish && !hasResult && !formState.init.data && !formState.init.isLoading

  useEffect(() => {
    if (!isFinish) {
      return
    }
    const url = new URL(window.location.href)
    const params = {}
    for (const key of url.searchParams.keys()) {
      params[key] = url.searchParams.get(key)
    }
    store.cardFormSlice.actions.setUpdate({params})
  }, [isFinish, loc])

  useEffect(() => {
    if (needsInit) {
      store.cardFormSlice.actions.fetchInit()
    }
  }, [needsInit])

  if (hasResult) {
    return <CardStatusPage/>
  }

  if (formState.init.data && !isFinish) {
    return <CardPage/>
  }

  return <LoadingPage/>
}
